import createAction, {ReducerActionInterface} from "../../../lib/reducer.utils";
import {RootReducerState} from "../../root-reducer";

export interface UserModel {
    id: number;
    name: string;
    email: string;
    token: string;
    isAdmin: boolean;
    isAuthenticated: boolean;
}

/* Actions */
export const UserActionTypes = {
    SET_USER: "user/SET_USER",
    GET_USER: "user/GET_USER",
    SET_TOKEN: "user/SET_TOKEN",
    GET_TOKEN: "user/GET_TOKEN",
    UPDATE_USER: 'user/UPDATE_USER',
    SET_IS_AUTHENTICATED: 'user/SET_IS_AUTHENTICATED',

}

/* use in the selectors */
const INITIAL_STATE: UserModel = {
    id: 1,
    name: "",
    email: "",
    token: "",
    isAdmin: false,
    isAuthenticated: false
}

export const userReducer = (state: UserModel = INITIAL_STATE, action: ReducerActionInterface) => {
    const {type, payload} = action;

    switch (type) {
        case UserActionTypes.SET_TOKEN:
            return {
                ...state,
                token: payload
            }
        case UserActionTypes.GET_TOKEN:
            return state.token
        case UserActionTypes.UPDATE_USER:
            return {
                ...state,
                username: payload.username,
                isAdmin: payload.isAdmin,
                name: payload.name
            }
        case UserActionTypes.SET_USER:
            return {
                id: payload?.id ? payload.id :  1,
                username: payload?.username ?? null,
                token: payload?.token ?? null,
                isAdmin: payload?.isAdmin ?? false,
                name: payload?.name ?? null
            }
        case UserActionTypes.GET_USER:
            return {
                name: state.name,
                token: state.token,
                isAdmin: state.isAdmin
            };
        case UserActionTypes.SET_IS_AUTHENTICATED:
            return {
                ...state,
                isAuthenticated: payload
            }
        default:
            return state;
    }
};

/* Selectors */
export const getToken = (state: RootReducerState) => state.user.token;
export const getCurrentUser = (state: RootReducerState) => state.user;
export const isAuthenticated = (state: RootReducerState) => state.user.isAuthenticated;

/* Actions */
export const setToken = (token: string | null) => createAction({
    type: UserActionTypes.SET_TOKEN,
    payload: token
})

export const setCurrentUser = (user: UserModel | null) => createAction({
    type: UserActionTypes.SET_USER,
    payload: user
})

export const updateUser = (payload: any) => createAction({
    type: UserActionTypes.UPDATE_USER,
    payload: payload
})

export const setIsAuthenticated = (payload: boolean) => createAction({
    type: UserActionTypes.SET_IS_AUTHENTICATED,
    payload
})